import Vue from 'vue'
import { CChartBar, CChartLine, CChartHorizontalBar } from '@coreui/vue-chartjs'
Vue.component('CChartBar', CChartBar)
Vue.component('CChartLine', CChartLine)
Vue.component('CChartHorizontalBar', CChartHorizontalBar)
